import React from 'react';

export interface NewLootBoxType {
    name: string;
    description: string;
    size: number;
    minBaseScore: number;
    maxBaseScore: number;
}

export interface ConfigInputProps {
    label: string;
    name: string;
    labelTitle?: string;
    newLootBox: NewLootBoxType;
    handleChange: (e, name, type) => void;
}

export function ConfigInput({ name, label, labelTitle, newLootBox, handleChange }: ConfigInputProps) {
    return (
        <div className="input-container number">
            <label htmlFor={name} title={labelTitle}>
                {label}
            </label>
            <input
                value={newLootBox[name]}
                onChange={(e) => handleChange(e, name, 'general')}
                type="number"
                id={name}
                name={name}
                min={0}
            />
        </div>
    );
}
